import { createSlice } from "@reduxjs/toolkit";

// Il cambiamento di filtersObject provoca la ripetizione della chiamata per le activities in AllActivities.jsx
const filtersSlice = createSlice({
    name: 'filters',
    initialState: {
        filtersObject: {}
    },
    reducers: {
        // setNewFilters AGGIUNGE filtri all'oggetto filtersObject
        setNewFilters: (state, action) => { // Il nome corretto sarebbe addNewFilters
            const newFilters = action.payload;
            state.filtersObject = {
                ...state.filtersObject,
                ...newFilters
            }
        },
        setActivityTypeNull: (state) => {
            state.filtersObject.activityType = null
        },
        setCategoryNull: (state) => {
            state.filtersObject.category = null
        },
        emptyFilters: (state) => {
            state.filtersObject = {}
        }
    }
})

export const { setNewFilters, emptyFilters, setCategoryNull, setActivityTypeNull } = filtersSlice.actions;
export default filtersSlice.reducer;